import { useRouter } from 'next/router'

const useCTABrandNewColors = () => {
  const { asPath } = useRouter()

  const pathname = asPath?.split('?')[0]

  const newColorBaselinedLPS = [
    // Home page
    '/',
    // Meta page LP
    '/life/get-life-insurance/',
    // Affiliates (non prefill)
    '/life/quick-online-quote/',
    // Affiliates (prefill)
    '/life/online-life-quote/',
    // Twitter
    '/life/life-insurance-now/',
    // Search (non branded)
    '/life/easy-term-life/',
    // Tiktok
    '/life/life-insurance-online/',
    // Search (branded)
    '/life/ethos-term-life-insurance/',
  ]

  return newColorBaselinedLPS.includes(pathname)
}

export default useCTABrandNewColors
